import { type ClassValue, clsx } from 'clsx';

export const twCn = (...inputs: ClassValue[]) => {
  return clsx(inputs);
};
